<template>
  <div>
    <header>
        <div class="header">
          <a href='https://ipnet.ua' target="_blank" class="header__logo">
            <img src="../../assets/logo.svg" alt="">
          </a>
          <span class="header__contacts">
            <span class="phone">
              <a href="tel:+380445070505">(044) 507 05 05</a>
            </span>
            <span class="d-none d-sm-flex d-md-flex d-lg-flex d-xl-flex">
              &nbsp;&nbsp;|&nbsp;&nbsp;
            </span>
            <a href="https://ipnet.ua" class="site" target="_blank">
              ipnet.ua
            </a>
          </span>
          <img v-if='$vuetify.breakpoint.lgAndUp' src="../../assets/header-xl-t.png">
          <img v-if='$vuetify.breakpoint.md' src="../../assets/header-lg-t.png">
          <img v-if='$vuetify.breakpoint.sm' src="../../assets/header-md-t.png">
          <img v-if='$vuetify.breakpoint.xs' src="../../assets/header-xs-t.png">
        </div>
        <div class="header-bottom">
            <div class="header-bottom__title">
                <span>
                    Підключайся до оновленої мережі IPNET
                </span>
            </div>
        </div>
    </header>
    <main class="main-block">
      <div class="main-block__triangle"></div>
      <div class="main-block__content block-shadow">
        <div class="tariff-cards">
          <CardItem :cardOptions="cardOption" v-for="(cardOption, index) of cardsOptions" :key="index"></CardItem>
        </div>
        <OrderForm :landingCodename="landingCodename" :gaFormTag="'gb199_order_middle'"></OrderForm>
      </div>
    </main>
    <Advantages :advantagesOptions="advantagesOptions"></Advantages>
    <coverMap :landingCodename="landingCodename" :gaFormTag="'gb199_order_bottom_map'"></coverMap>
    <footerSection></footerSection>
  </div>
</template>

<script>
import coverMap from '../../components/CoverMap.vue';
import footerSection from '../../components/FooterSection.vue';
import Advantages from '../../components/Advantages.vue';
import CardItem from '../../components/CardItem';
import OrderForm from '../../components/OrderForm';
import cardsOptions from './cardsOptions'

export default {
  name: "cleanGigabit",
  components: {
    coverMap,
    footerSection,
    CardItem,
    Advantages,
    OrderForm
  },
  metaInfo: {
      title: 'Акція. Роутер за 550 грн та Інтернет у подарунок від IPnet.ua',
      titleTemplate: null,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: 'Купуй Сучасний Роутер за 550 грн та отримуй Гігабітний Інтернет на 5 місяців.',
      }]
  },
  data() {
    this.landingCodename = 'clear_gigabit_router'
    this.cardsOptions = cardsOptions
    this.advantagesOptions = {
      title: 'ДОДАТКОВІ ПЕРЕВАГИ ВІД КОМПАНІЇ IPNET',
      options: [
        {
          text: 'БЕЗЛІМІТНИЙ ІНТЕРНЕТ',
          icon: require('../../assets/icons/advantages-unlim.png')
        },
        {
          text: 'ТЕХНІЧНА ПІДТРИМКА 24/7',
          icon: require('../../assets/icons/advantages-support.png')
        },
        {
          text: 'ЦИФРОВЕ ТЕЛЕБАЧЕННЯ',
          icon: require('../../assets/icons/advantages-tv.png')
        }
      ]
    }
    return {
      landingCodename: this.landingCodename,
      cardsOptions: this.cardsOptions,
      advantagesOptions: this.advantagesOptions,
    }
  }
}

</script>

<style scoped>
/*
primary color: #ab2956
*/
.header {
  position: relative;
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: left top;
}
.header img {
  width: 100%;
  height: auto;
  display: block;
}
.header__logo {
  position: absolute;
  width: 152px;
  height: 101px;
  left: 18%;
  top: 12%;
  transform: translate(-55%, -5%);
}
.header__tariff-name {
  position: absolute;
  font-weight: 800;
  line-height: 40px;
  font-size: 40px;
  color: #ab2956;
  display: flex;
  flex-direction: column;
  align-items: center;
  left: 40.5%;
  top: 22%;
  transform: translate(-55%, -5%);
}
.header__tariff-name div:first-child {
  font-weight: 500;
  font-size: 24px;
}
.header__contacts {
  position: absolute;
  display: flex;
  left: 64%;
  top: 15%;
  transform: translate(-54%, -10%);
  font-size: 26px;
}
.header__contacts a {
  text-decoration: none;
  color: #000000;
}

.header-bottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
    .header-bottom__title {
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      width: 100%;
      background-color: #ab2956;
      height: 50px;
      text-transform: uppercase;
      color: #ffffff;
      font-weight: 800;
      font-size: 28px;
    }

.main-block {
  position: relative;
  min-height: 700px;
  padding: 25px;
  background-image: url("../../assets/middle-bg-lg.png");
  background-size: auto 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.main-block__triangle {
  top: -1px;
  width: 0;
  height: 0;
  position: absolute;
  border-style: solid;
  border-width: 15px 30px 0 30px;
  border-color: #ab2956 transparent transparent transparent;
}

.main-block__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #f3f3f399;
  border-radius: 25px;
  padding: 25px;
}
    .tariff-cards {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 30px;
    }
    /*HEADER MEDIA QUERY */
    @media (max-width: 1263px) {
      .header__contacts {
        left: unset;
        right: 5%;
        top: 5%;
        transform: unset;
      }
      .header__logo {
        top: 0;
        left: 5%;
        transform: translate(0, 0);
      }
    }
    @media (max-width: 820px) {
      .header__logo {
        top: 0;
        left: 5%;
        transform: translate(0, 0);
      }
    }
    @media (max-width: 657px) {
      .header__logo {
        top: 0;
        left: 0;
        transform: translate(0, 0);
      }
    }
    @media (max-width: 600px) {
      .header__contacts {
        left: unset;
        right: 5%;
        transform: unset;
        flex-direction: column;
        justify-content: flex-end;
      }
      .header__contacts a {
        display: flex;
        justify-content: flex-end;
      }
      .header__logo {
        top: 2%;
      }
    }
    @media (max-width: 530px) {
      .header__logo {
        top: 2%;
      }
    }
    @media (max-width: 400px) {
      .header__contacts {
        font-size: 20px;
      }
      .header__logo {
        width: 100px;
      }
    }

    /* MEDIA QUERY */
    @media (max-width: 800px) {
      .header-bottom__title, .additional-advantages__title {
        font-size: 24px;
        height: auto;
        line-height: 26px;
        padding: 15px 0 15px 0;
      }
      .tariff-cards {
        flex-direction: column;
        margin-bottom: 0;
      }
    }
    @media (max-width: 600px) {
    }
    @media (min-width: 340px ) and (max-width: 600px) {
    }
    @media (max-width: 320px) {
    }
</style>